module.exports = __webpack_public_path__ + "img/c1.841d18cd.png";